<template>
  <div class="width100 margin-auto">
    <el-skeleton class="width100" :loading="true" animated :throttle="500">
      <template slot="template">
        <div class="backwhite">
          <div class="textalign-center f14">项目详情</div>
          <div class="f14 lineheight30">
            <div class="pad-top10 flexleft">
              <div>项目名称 : {{ title }}</div>
            </div>
            <div class="pad-top10 flexleft">
              <div>项目类别 : {{ cate_id }}</div>
            </div>
            <div class="pad-top10 flexleft">
              <div>项目备注 : {{ remark }}</div>
            </div>
            <div class="width100 pad-top10">
              <p>项目附件 :</p>
              <p
                class="
                  bluecolor
                  filebtnbg
                  width98
                  margin-auto margin-top10
                  flex-betweencen
                "
                v-for="(item, index) in files"
                :key="index"
              >
                <span
                  class="text-ellipsis cursorpointer"
                  @click="seafile(index)"
                  ><img src="@/assets/barsvg/icon／12fj.png" alt="" />
                  {{ item.original_name }}</span
                >
                <span @click="removefile(index)">
                  <span class="removebtn cursorpointer"
                    ><i class="el-icon-close"></i
                  ></span>
                </span>
              </p>
            </div>
          </div>
        </div>

        <div class="width100 backwhite margin-top10 pad-top20 flex-betweencen">
          <el-upload
            class="avatar-uploader"
            :action="Apisrc"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :on-error="handleerror"
            :on-change="onchange"
            :data="user"
            :headers="head"
          >
            <el-button type="primary">
              <i slot="prefix" class="iconfont iconfonts icon-bianji3"></i
              >上传附件
            </el-button>
          </el-upload>

          <div class="textalign-right">
            <el-button @click="dialognull()">取 消</el-button>
            <el-button
              class="margin-top20"
              type="primary"
              @click="dialognull()"
            >
              确 定
            </el-button>
          </div>
        </div>
      </template>
    </el-skeleton>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  entdesignproductdetail,
  entdesignproductdeletefile,
} from "@/api/newhead/newhead.api";
import { Base64 } from "js-base64";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      title: "",
      cate_id: "",
      remark: "",
      files: [],
      productmodification: "",
      filelist: [],
      rowid: "",
      user: {
        file: "",
        design_id: "",
      },
      head: {
        token: window.sessionStorage.getItem("token"),
      },
    };
  },
  inject: ["reload"],
  methods: {
    // 上传
    beforeUpload(file) {
      this.head.token = window.sessionStorage.getItem("token");
      this.$loadings.show(); // 显示loading
    },
    handleprogress(file, fileList) {
      this.user.filename = fileList.name;
    },

    handleAvatarSuccess(response, file, fileList) {
      if (response.msg == "上传文件后缀不允许") {
        this.dialogVisiblenull = true;
        this.errormessage = response.msg;
      } else {
        this.responseid = response.data.id;
        this.voucher = response.data.url;
        this.fund = file.name;
        this.$loadings.hide(); // 隐藏loading
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success",
        });
        BUS.$emit("indusdesign", 1);
      }
    },
    handleerror(error, file, fileList) {
      let myError = error.toString(); //转字符串
      myError = myError.replace("Error: ", ""); // 去掉前面的" Error: "
      myError = JSON.parse(myError); //转对象
      this.$loadings.hide(); // 隐藏loading
      this.dialogVisiblenull = true;
      this.errormessage = myError.msg;
    },

    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    onchange(file, fileList) {
      this.user.file =
        document.getElementsByClassName("el-upload__input")[0].value;
    },

    // 删除附件
    removefile(index) {
      this.$confirm("此操作将删除此附件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          entdesignproductdeletefile({
            id: this.files[index].id,
          }).then((res) => {
            if (res.data.code == 200) {
              this.reload();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    // 预览附件
    seafile(index) {
      var url = window.g.Apisrc + this.files[index].url;
      window.open(
        window.g.previewurl + "?url=" + encodeURIComponent(Base64.encode(url))
      );
    },
    dialognull() {
      BUS.$emit("indusdesign", 2);
    },
  },
  created() {
    this.Apisrc = window.g.ApiUrl + "/ent_design_product/uploader";
    this.productmodification = window.sessionStorage.getItem(
      "productmodification"
    );
    this.user.design_id = window.sessionStorage.getItem("productmodification");
    // 获取项目详情
    entdesignproductdetail({ id: this.productmodification }).then((res) => {
      if (res.data.code == 200) {
        this.title = res.data.data.title;
        if (res.data.data.cate == null) {
          this.cate_id = "";
        } else {
          this.cate_id = res.data.data.cate.name;
        }
        this.remark = res.data.data.remark;
        this.id = res.data.data.id;
        this.files = res.data.data.files;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
  mounted() {
    BUS.$on("productmodification", (data) => {
      this.user.design_id = data;
      // 获取项目详情
      entdesignproductdetail({ id: data }).then((res) => {
        if (res.data.code == 200) {
          this.title = res.data.data.title;

          if (res.data.data.cate == null) {
            this.cate_id = "";
          } else {
            this.cate_id = res.data.data.cate.name;
          }
          this.remark = res.data.data.remark;
          this.id = res.data.data.id;
          this.files = res.data.data.files;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    });
  },
};
</script>
<style scoped>
.removebtn {
  display: inline-block;
  width: 12px;
  height: 12px;
  color: #fff;
  background: #969eac;
  border-radius: 50%;
  position: relative;
  top: 3px;
}
.el-icon-close {
  font-size: 12px !important;
  position: absolute;
}
.filebtnbg {
  background: #f6f7fb;
  margin-bottom: 10px;
  padding: 3px 10px;
}
.removefile {
  position: relative;
  top: 6px;
  left: 5px;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>